// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fab-add-promo-codes{position:absolute;bottom:16px;right:16px}.empty-promo-codes{margin-top:3rem;text-align:center;padding:0 16px}\n", ""]);
// Exports
module.exports = exports;
